import CoreAPI from "../coreAPI";

export default function APIHRIntegration(coreAPI: CoreAPI) {
  return {
    async getFinchClientId() {
      try {
        return await coreAPI.authCall<string>({
          endpoint: `/hrIntegration/credentials`,
        });
      } catch (e) {
        // TODO: set up error
        return "";
      }
    },
    async createHRIntegration(code: string) {
      try {
        return await coreAPI.authCall<any>({
          method: "POST",
          endpoint: `/hrIntegration?accessCode=${code}`,
        });
      } catch (e) {
        // TODO: set up error
      }
    },
  };
}
